module.exports = __webpack_public_path__ + "assets/img/carousel-2-320.aed61db6.webp";